import { createContext } from "react";

export type ToastTone = "success" | "error";

export type ShowToast = (message: string, tone?: ToastTone) => void;

export type VisibleToast = {
  message: string;
  tone: ToastTone;
  shownAt: number;
};

export const ToastCtx = createContext<ShowToast | null>(null);
